import gql from 'graphql-tag'

export default gql`
  query PayrollInfoQuery($loanId: Int!) {
    loan(rid: $loanId) {
      rid
      businesses {
        borrowerType
        questions {
          number
          description
          selectOptions
        }
        answers {
          rid
          value
          type
          questionNumber
        }
      }
    }
  }
`
